import { Navigate, Route, Routes } from "react-router-dom";
import DocumentsScreen from "../pages/documents";
import DocumentsDetailScreen from "../pages/documentsDetail";
import DocumentsWebViewScreen from "../pages/documentsWebView";
import ContactsScreen from "../pages/contacts";

export default function AppRoutes() {
  return (
    <Routes>
      {/* Default route */}
      <Route path="/" element={<Navigate to="/documents" replace />} />

      {/* Documents stack */}
      <Route path="/documents" element={<DocumentsScreen />} />
      <Route path="/documents/:id" element={<DocumentsDetailScreen />} />
      <Route path="/documents/webview" element={<DocumentsWebViewScreen />} />

      {/* Contacts tab */}
      <Route path="/contacts" element={<ContactsScreen />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/documents" replace />} />
    </Routes>
  );
}
